export const getTrackingPixel = (src) => {
    return src ? (
        <img
            className="trackingPixel"
            src={src}
            alt=""
            height="1px"
            width="1px"
            style={{ position: "absolute" }}
        />
    ) : null;
};

export const getScltClassName = (str) => `sclt-${str.replace(/-/gi, "")}`;
